<div class="bg-white rounded-2xl shadow-sm border border-slate-500 overflow-hidden">
  <div class="px-8 py-1 border-b border-slate-300 flex items-center justify-between bg-white">
    <div class="flex items-center gap-3">
      <button (click)="toggleReports()" [attr.aria-expanded]="showContent()" aria-controls="card-panel-content"
        class="flex items-center justify-center w-10 h-10 rounded-lg hover:bg-blue-100 transition">
        <span class="sr-only">{{ showContent() ? 'Collapse' : 'Expand' }} {{ title() }}</span>
        @if (showContent()) {
        <!-- Up Arrow -->
        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-700" viewBox="0 0 20 20"
          fill="currentColor">
          <path fill-rule="evenodd"
            d="M5.23 12.21a.75.75 0 001.06.02L10 8.77l3.71 3.46a.75.75 0 101.02-1.1l-4.25-3.97a.75.75 0 00-1.02 0L5.21 11.13a.75.75 0 00.02 1.08z"
            clip-rule="evenodd" />
        </svg>
        } @else {
        <!-- Down Arrow -->
        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-700" viewBox="0 0 20 20"
          fill="currentColor">
          <path fill-rule="evenodd"
            d="M14.77 7.79a.75.75 0 00-1.06-.02L10 11.23 6.29 7.77a.75.75 0 10-1.02 1.1l4.25 3.97c.3.28.77.28 1.06 0l4.25-3.97a.75.75 0 00-.02-1.08z"
            clip-rule="evenodd" />
        </svg>
        }
      </button>
      <h2 class="text-[18px] font-bold text-slate-800">{{ title() }}</h2>
    </div>
    <ng-content select="[cardHeaderActions]"></ng-content>
  </div>
  @if (showContent()) {
  <div id="card-panel-content">
    <ng-content></ng-content>
  </div>
  }
</div>